import { Button } from 'UIPackage/MainModule/components/Button';

import styles from './TitleWithAddButton.module.scss';

interface ITitleWithAddButtonProps {
  text: string;
  id?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const TitleWithAddButton = ({ text, onClick, disabled = false, id }: ITitleWithAddButtonProps) => (
  <>
    {text}
    &nbsp;
    <Button
      disabled={disabled}
      type="button"
      className={styles.Button}
      variant="link"
      color="primary"
      id={id}
      text="Добавить"
      onClick={onClick}
    />
  </>
);
